<ng-container [formGroup]="ratingForm">
    <h3 class="form-header" mat-dialog-title i18n="@@3b5fe649ccf01c7d8a58689f86d59cf87475ea28" t="3b5fe649ccf01c7d8a58689f86d59cf87475ea28">Supplier Review</h3>

    <div class="grid">
        <div class="row" fxLayoutGap="10px">
            <div fxFlex="30">
                <tsl-form-field fxFlex="95">
                    <tsl-label i18n="@@607de17c2a755f65775881c19e276e7c933bcf94" t="607de17c2a755f65775881c19e276e7c933bcf94">Category</tsl-label>
                    <tsl-select fullWidth required formControlName="category">
                        <tsl-option *ngFor="let item of ratePurpose$ | async" [value]="item.id">
                            {{ this.translateService.get(item.purpose) }}</tsl-option>
                    </tsl-select>
                    <tsl-error *ngIf="category.invalid" i18n="@@d258b1d065478feabe75fff88e9d152397ea486e" t="d258b1d065478feabe75fff88e9d152397ea486e">Required</tsl-error>
                </tsl-form-field>
            </div>

            <div fxFlex>
                <div fxFlex="95">
                    <tsl-range-slider [options]="ratingOptions" formControlName="rate"></tsl-range-slider>
                    <tsl-error *ngIf="rate.invalid" i18n="@@d258b1d065478feabe75fff88e9d152397ea486e" t="d258b1d065478feabe75fff88e9d152397ea486e">Required</tsl-error>
                </div>
            </div>
        </div>

        <div class="row">
            <div fxFlex="30">
                <tsl-form-field fxFlex="95">
                    <tsl-label i18n="@@fdf7cbdc140d0aab0f0b6c06065a0fd448ed6a2e" t="fdf7cbdc140d0aab0f0b6c06065a0fd448ed6a2e">Title</tsl-label>
                    <input tslInput fullWidth required maxlength="15" formControlName="subject" />
                    <tsl-error *ngIf="subject.invalid" i18n="@@e5f24fc7a2bf50bd61d109dd9cad3fbff6ec7add" t="e5f24fc7a2bf50bd61d109dd9cad3fbff6ec7add">Required</tsl-error>
                </tsl-form-field>
            </div>
        </div>

        <div class="row" fxLayoutGap="10px">
            <div fxFlex="60">
                <tsl-form-field fxFlex="97">
                    <tsl-label i18n="@@eec715de352a6b114713b30b640d319fa78207a0" t="eec715de352a6b114713b30b640d319fa78207a0">Description</tsl-label>
                    <textarea tslInput fullWidth required rows="5" cols="100" maxlength="500"
                        formControlName="note"></textarea>
                    <tsl-error *ngIf="note.invalid" i18n="@@e5f24fc7a2bf50bd61d109dd9cad3fbff6ec7add" t="e5f24fc7a2bf50bd61d109dd9cad3fbff6ec7add">Required</tsl-error>
                </tsl-form-field>
            </div>

            <div fxFlex>
                <label class="label" i18n="@@01271770639fc43af38cf135f46a582f84d0630d" t="01271770639fc43af38cf135f46a582f84d0630d">Evidence</label>
                <div class="upload-bar">
                    <label for="rating_file" *ngIf="!viewMode">
                        <tsl-icon size="small">backup</tsl-icon><span class="file-input-label label" i18n="@@2c7dc726e93bcf3ca2f316bbebe96fa1e5288ba0" t="2c7dc726e93bcf3ca2f316bbebe96fa1e5288ba0">Browse</span>
                    </label>
                    <input id="rating_file" class="file-input" type="file" (change)="onAddFile($event.target.files[0])"
                        accept=".doc,.docx,.xls,.xlsx,.pdf,.txt,.ppt,.pptx,.pstx,.jpg,.jpeg,.xps" />
                    <div class="image-list">
                        <ul>
                            <li *ngFor="let file of data.attachments">
                                <div class="file-img {{getFileType(file.fileName)}}" tslTooltip="{{file.fileName}}"
                                    (click)="onDownloadAttachment(file)">
                                </div>
                            </li>
                            <li class="no-saved" *ngFor="let file of data.newFiles">
                                <div class="file-img {{getFileType(file.name)}}" matTooltip="{{file.name}}"
                                    (click)="onDownloadFile(file)"></div>
                                <tsl-icon size="small" status="error" (click)="onDeleteFile(file)">delete</tsl-icon>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" fxLayoutGap="10px" *ngIf="!viewMode">
            <div fxFlex="30">
                <tsl-form-field fxFlex="95">
                    <tsl-label i18n="@@e191188dab85b13ad09755c107ad074bea773f14" t="e191188dab85b13ad09755c107ad074bea773f14">Tag type</tsl-label>
                    <tsl-select fullWidth formControlName="fieldType">
                        <tsl-option value="0"></tsl-option>
                        <tsl-option value="1" i18n="@@d67d17a81be05a2457abe2446c6fbe20b1d3244d" t="d67d17a81be05a2457abe2446c6fbe20b1d3244d">Equipment/Tool</tsl-option>
                        <tsl-option value="2" i18n="@@34746fb1c7f3d2194d99652bdff89e6e14c9c4f4" t="34746fb1c7f3d2194d99652bdff89e6e14c9c4f4">Contact</tsl-option>
                        <tsl-option value="3" i18n="@@4a6349fab642dd11764bc101dd27c27d7cdea3d2" t="4a6349fab642dd11764bc101dd27c27d7cdea3d2">Part</tsl-option>
                    </tsl-select>
                </tsl-form-field>
            </div>

            <div fxFlex="30">
                <!-- Category -->
                <tsl-form-field fxFlex="95" *ngIf="fieldType.value == 1">
                    <tsl-label i18n="@@ffa276bdf6656c5d7c8d2cacbcac9fdac49e9497" t="ffa276bdf6656c5d7c8d2cacbcac9fdac49e9497">Equipment/Tool Category</tsl-label>
                    <tsl-select fullWidth (selectionChange)="onToolCategoryChange($event)">
                        <tsl-option *ngFor="let item of categories$ | async" [value]="item">
                            {{ translateService.get(item.category) }}</tsl-option>
                    </tsl-select>
                </tsl-form-field>

                <!-- Contacts -->
                <tsl-form-field fxFlex="95" *ngIf="fieldType.value == 2">
                    <tsl-label i18n="@@34746fb1c7f3d2194d99652bdff89e6e14c9c4f4" t="34746fb1c7f3d2194d99652bdff89e6e14c9c4f4">Contact</tsl-label>
                    <input [tslAutocomplete]="autoContact" tslInput fullWidth [formControl]="contactControl" />
                    <tsl-autocomplete #autoContact="tslAutocomplete" (optionSelected)="onFieldChange($event.option)">
                        <tsl-option *ngFor="let item of filteredContacts$ | async" [value]="item">
                            {{item.firstName.newValue}} {{item.lastName.newValue}}</tsl-option>
                    </tsl-autocomplete>
                </tsl-form-field>

                <!-- Parts -->
                <tsl-form-field fxFlex="95" *ngIf="fieldType.value == 3">
                    <tsl-label i18n="@@4a6349fab642dd11764bc101dd27c27d7cdea3d2" t="4a6349fab642dd11764bc101dd27c27d7cdea3d2">Part</tsl-label>
                    <tsl-select fullWidth (selectionChange)="onFieldChange($event)">
                        <tsl-option *ngFor="let item of parts$ | async" [value]="item">
                            {{ item.partNumber }} {{ item.description }}</tsl-option>
                    </tsl-select>
                </tsl-form-field>
            </div>

            <div fxFlex="30">
                <!-- Subcategory -->
                <tsl-form-field fxFlex="95" *ngIf="fieldType.value == 1">
                    <tsl-label i18n="@@992d9235c27100ade5ed9ed1c681cc2cf5e33dc0" t="992d9235c27100ade5ed9ed1c681cc2cf5e33dc0">Equipment/Tool Subcategory</tsl-label>
                    <tsl-select fullWidth (selectionChange)="onFieldChange($event)">
                        <tsl-option *ngFor="let item of filteredsubcategories$ | async" [value]="item">
                            {{ translateService.get(item.subcategory) }}</tsl-option>
                    </tsl-select>
                </tsl-form-field>
            </div>
        </div>

        <div class="row" style="height: 40px;">
            <div fxFlex fxLayoutGap="5px">
                <tsl-chip [removable]="!viewMode" *ngFor="let item of data.rateFields" (removed)="onRemoveTag(item)">
                    {{item.externalValue}}</tsl-chip>
            </div>
        </div>
    </div>
    <br>

    <div class="grid">
        <div fxFlex *ngIf="viewMode" fxLayout="column">
            <tsl-label><span i18n="@@6f365b149f2ad02a7b714f57ecbcb1eb7b73bc14" t="6f365b149f2ad02a7b714f57ecbcb1eb7b73bc14">Rated by: </span>{{ data.createdBy }}</tsl-label>
            <tsl-label><span i18n="@@22b147f95434c9311ff3ccc61afb59f781fcd6ac" t="22b147f95434c9311ff3ccc61afb59f781fcd6ac">Rated on: </span>{{ data.createdOn | date }}</tsl-label>
        </div>
        <div fxFlex class="right">
            <button tsl-button outline color="black" size="small" (click)="onClose()" i18n="@@f4e529ae5ffd73001d1ff4bbdeeb0a72e342e5c8" t="f4e529ae5ffd73001d1ff4bbdeeb0a72e342e5c8">Close</button>
            <button tsl-button filled color="blue" size="small" [disabled]="ratingForm.invalid" *ngIf="!viewMode"
                (click)="onSave()" i18n="@@52c9a103b812f258bcddc3d90a6e3f46871d25fe" t="52c9a103b812f258bcddc3d90a6e3f46871d25fe">Save</button>
        </div>
    </div>
</ng-container>